var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
var StyledLayout = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  box-sizing: border-box;\n  max-width: calc(100% - ", "px);\n  margin: 0 auto;\n  padding: 20vh 0 50px;\n  text-align: center;\n"], ["\n  width: 100%;\n  box-sizing: border-box;\n  max-width: calc(100% - ", "px);\n  margin: 0 auto;\n  padding: 20vh 0 50px;\n  text-align: center;\n"])), function (props) { return props.theme.spacing * 4; });
var StyledLayoutSmall = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  box-sizing: border-box;\n  max-width: calc(100% - ", "px);\n  margin-right: 5px;\n  text-align: right;\n"], ["\n  width: 100%;\n  box-sizing: border-box;\n  max-width: calc(100% - ", "px);\n  margin-right: 5px;\n  text-align: right;\n"])), function (props) { return props.theme.spacing * 4; });
export default (function (props) {
    switch (props.appearance) {
        case "small":
            return _jsx(StyledLayoutSmall, { children: props.children });
        case "screen":
        default:
            return _jsx(StyledLayout, { children: props.children });
    }
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map